module.exports = __webpack_public_path__ + "img/xmark.98566f94.svg";